import { BrandInfoProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { LinkCta } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/LoggedOut/LoggedOutUnlockWholesalePriceLink";
import { ProductTileTrackingWrapperProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapperProps";
import { BrandInfo } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/BrandDetails/BrandInfo";
import { ProductLink } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/ProductLink";
import { PromotedTextBadge } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/PromotedBadge";
import { whichBatch10ProductTilesVariant } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingBatch10ProductTiles";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";

export const ProductTileBrandInformation = ({
  brandInfoProps,
  productTileTrackingWrapperProps,
}: {
  brandInfoProps?: BrandInfoProps;
  productTileTrackingWrapperProps?: ProductTileTrackingWrapperProps;
}) => {
  const {
    isBatch10ProductTilesV2orV3,
    isBatch10ProductTilesV3,
    isBatch10ProductTilesV4,
  } = whichBatch10ProductTilesVariant(
    brandInfoProps?.batch10ProductTilesVariant
  );
  return (
    <>
      {!isBatch10ProductTilesV2orV3 ? (
        <BrandInfo brandInfoProps={brandInfoProps} />
      ) : null}
      {productTileTrackingWrapperProps ? (
        <PromotedTextBadge
          isPromoted={productTileTrackingWrapperProps.isPromoted}
          promotedBy={productTileTrackingWrapperProps.promotedBy}
        />
      ) : null}
      {isBatch10ProductTilesV2orV3 || isBatch10ProductTilesV4 ? (
        <Column align="flex-start">
          <Spacer size="1x" />
          <ProductLink>
            <LinkCta hideLockIcon={isBatch10ProductTilesV3} />
          </ProductLink>
        </Column>
      ) : null}
    </>
  );
};
